import React from 'react'
import styled from 'styled-components'
import { Progress } from 'reactstrap'
import { ReactComponent as TopPanelBackImage } from '../../../images/TopHeaderPanel/TopPanel-BG-Back.svg'
import { ReactComponent as TopPanelFrontImage } from '../../../images/TopHeaderPanel/TopPanel-BG-White.svg'
import { ReactComponent as BulbIcon } from '../../../images/BulbIcon.svg'
import { ReactComponent as ActiveIcon } from '../../../images/ActiveIcon.svg'
import { ReactComponent as InactiveIcon } from '../../../images/InactiveIcon.svg'
import { ReactComponent as TrendArrow } from '../../../images/TrendArrow.svg'

//Trend icons
import { ReactComponent as AlertHighIcon } from '../../../images/AlertHighIcon.svg'
import { ReactComponent as AlertMedIcon } from '../../../images/AlertMedIcon.svg'
import { ReactComponent as AlertLowIcon } from '../../../images/AlertLowIcon.svg'

//Categories Icons
import { ReactComponent as DataAtRiskIcon } from '../../../images/CategoryLegend-DataAtRisk.svg'
import { ReactComponent as LateralMovementIcon } from '../../../images/CategoryLegend-LateralMovement.svg'
import { ReactComponent as MalwareIcon } from '../../../images/CategoryLegend-Malware.svg'
import { ReactComponent as OutdatedServiceIcon } from '../../../images/CategoryLegend-OutdatedService.svg'
import { ReactComponent as SpamIcon } from '../../../images/CategoryLegend-Spam.svg'

import { toCamelCase } from '../../../utils/toCamelCase'
import PieChartComponent from './PieChartComponent'

const MainWrapper = styled.div`
  background: radial-gradient(
    56.44% 50.93% at 50% 4.88%,
    #03204b 0,
    #1b1f25 100%
  );
  height: 350px;

  padding-left: 64px;
`

const TopWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  position: relative;
`
const Panel = styled.div`
  position: relative;
  text-align: center;
`

const StyledProgress = styled(Progress)`
  width: 550px;
  height: 7px;
  margin: auto;
  background-color: rgba(103, 107, 111, 0.5);
  border-radius: 0;
  clip-path: polygon(0.3% 100%, 0 0, 100% 0, 99.7% 100%);

  .bg-info {
    background-color: ${({ theme }) => theme.colors.scoreHigh} !important;
  }
`

const TopPanelBack = styled.div`
  svg {
    position: relative;
  }
`
const Number = styled.span`
  font-family: ${({ theme }) => theme.fonts.rajdhaniMedium};
  margin-left: 10px;
`

const PanelBackText = styled.span`
  color: ${({ theme }) => theme.colors.gray3};
  font-size: ${({ theme }) => theme.fontSize.s12};
  margin-left: 5px;
`

const PanelBackContentLeft = styled.div`
  top: 15px;
  color: white;
  position: absolute;
  padding-inline: 30px;
`

const PanelBackContentRight = styled.div`
  right: 0;
  top: 15px;
  color: white;
  position: absolute;
  padding-inline: 20px;
`

const TopPanelFront = styled.div`
  position: absolute;
  top: 1px;
  left: 50%;
  transform: translateX(-50%);
  .front {
    position: relative;
  }
`
const PanelFrontContent = styled.div`
  width: 100%;
  text-align: center;
  position: absolute;
  top: 0;
  padding: 10px;
  left: 50%;
  transform: translateX(-50%);
`
const Title = styled.div`
  font-weight: 500;
  text-transform: uppercase;
  font-size: ${({ theme }) => theme.fontSize.s14};
`

const SubTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSize.s12};
`
const PercentScore = styled.div`
  line-height: 1;
  margin-top: 3px;
  font-size: ${({ theme }) => theme.fontSize.s38};
  font-family: ${({ theme }) => theme.fonts.rajdhaniMedium};
  color: ${({ theme }) => theme.colors.scoreHigh};

  :after {
    content: '%';
    font-size: ${({ theme }) => theme.fontSize.s22};
  }
`

const BottomWrapper = styled.div`
  display: flex;
  position: relative;
  top: 80px;
  padding-inline: 30px;
`

const BottomSection = styled.div`
  width: 350px;
  margin-right: 90px;

  :last-of-type {
    margin-right: 0;
  }
`

const BottomTitle = styled.div`
  position: relative;
  color: ${({ theme }) => theme.colors.gray5};

  font-size: ${({ theme }) => theme.fontSize.s14};
  text-transform: uppercase;
  padding-bottom: 10px;
  :after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 2px;
    background-color: hsla(0, 0%, 100%, 0.1);
  }
`

const VectorsSection = styled.div`
  color: ${({ theme }) => theme.colors.white};

  margin-top: 25px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 30px 25px;
`

const SectionItem = styled.div``

const PercentRow = styled.span`
  display: flex;
  line-height: 0.5;
  svg {
    margin-left: 5px;
    align-self: center;
  }
`

const PercentValue = styled.span`
  font-size: ${({ theme }) => theme.fontSize.s30};
  font-family: ${({ theme }) => theme.fonts.rajdhaniMedium};
`

const TitleRow = styled.div`
  color: ${({ theme }) => theme.colors.gray4};

  font-size: ${({ theme }) => theme.fontSize.s12};
`

const Content = styled.div`
  color: ${({ theme }) => theme.colors.white};

  display: flex;
  position: relative;
`

const SeverityRow = styled.div`
  display: flex;
  align-items: center;

  span {
    color: ${({ theme }) => theme.colors.gray4};
  }
`

const SeverityValue = styled.div`
  font-size: ${({ theme }) => theme.fontSize.s30};
  font-family: ${({ theme }) => theme.fonts.rajdhaniMedium};
  margin-inline: 10px 6px;
`

const CategoriesRow = styled.div`
  display: flex;
  align-items: center;
  span {
    color: ${({ theme }) => theme.colors.gray4};
    font-size: ${({ theme }) => theme.fontSize.s12};
  }
  svg {
    margin-bottom: 2px;
  }
`

const CategoriesValue = styled.div`
  font-size: ${({ theme }) => theme.fontSize.s18};
  font-family: ${({ theme }) => theme.fonts.rajdhaniMedium};
  font-weight: 600;
  margin-inline: 10px 4px;
`

const SEVERITY_COLORS = {
  high: '#CE2D5E',
  medium: '#ED813B',
  low: '#FFE28B',
}

const SEVERITY_ICONS = {
  high: <AlertHighIcon />,
  medium: <AlertMedIcon />,
  low: <AlertLowIcon />,
}

const CATEGORIES_COLORS = {
  spam: '#5D95EB',
  lateralMovement: '#5A3CD2',
  malware: '#698EAF',
}

const CATEGORIES_ICONS = {
  spam: <SpamIcon />,
  lateralMovement: <LateralMovementIcon />,
  malware: <MalwareIcon />,
  outdatedService: <OutdatedServiceIcon />,
  dataAtRiskIcon: <DataAtRiskIcon />,
}

//dummy data
const data = {
  recommendationsNumber: 11,
  activeNumber: 5,
  inactiveNumber: 4,
  potentialScore: 88,
  mainScore: 76,
  vectorsData: [
    {
      name: 'Email',
      value: 45,
    },
    {
      name: 'Web',
      value: 23.64,
    },
  ],
  severityData: [
    { name: 'High', value: 40 },
    { name: 'Medium', value: 30 },
    { name: 'Low', value: 10 },
  ],
  categoriesData: [
    { name: 'Spam', value: 400 },
    { name: 'Lateral Movement', value: 300 },
    { name: 'Malware', value: 100 },
  ],
}

const Header: React.FC = () => {
  const {
    activeNumber,
    inactiveNumber,
    mainScore,
    potentialScore,
    recommendationsNumber,
    severityData,
    categoriesData,
    vectorsData,
  } = data

  const vectorsElements = vectorsData.map((item, key) => (
    <SectionItem key={key}>
      <PercentRow>
        <PercentValue>
          <span>{item.value}</span>%
        </PercentValue>
        <TrendArrow />
      </PercentRow>
      <TitleRow>{item.name}</TitleRow>
    </SectionItem>
  ))

  const severityElements = severityData.map((item, key) => (
    <SeverityRow key={key}>
      {SEVERITY_ICONS[toCamelCase(item.name)]}
      <SeverityValue>{item.value}</SeverityValue>
      <span>{item.name}</span>
    </SeverityRow>
  ))

  const categoriesElements = categoriesData.map((item, key) => (
    <CategoriesRow key={key}>
      {CATEGORIES_ICONS[toCamelCase(item.name)]}
      <CategoriesValue>{item.value}</CategoriesValue>
      <span>{item.name}</span>
    </CategoriesRow>
  ))

  return (
    <MainWrapper>
      <TopWrapper>
        <Panel>
          <StyledProgress color="info" value={mainScore} />

          <TopPanelBack>
            <TopPanelBackImage />
            <PanelBackContentLeft>
              <BulbIcon />
              <Number>{recommendationsNumber}</Number>
              <PanelBackText>Recommendations</PanelBackText>
            </PanelBackContentLeft>
            <PanelBackContentRight>
              <ActiveIcon />
              <Number style={{ marginLeft: '5px' }}>{activeNumber}</Number>
              <PanelBackText style={{ marginLeft: '4px' }}>
                Active
              </PanelBackText>
              <InactiveIcon style={{ marginLeft: '17px' }} />
              <Number style={{ marginLeft: '5px' }}>
                {inactiveNumber}
              </Number>
              <PanelBackText style={{ marginLeft: '4px' }}>
                Inactive
              </PanelBackText>
            </PanelBackContentRight>
          </TopPanelBack>

          <TopPanelFront>
            <TopPanelFrontImage className="front" />
            <PanelFrontContent>
              <Title>Protection Score</Title>
              <SubTitle>
                <span>{potentialScore}%</span> Potential score
              </SubTitle>
              <PercentScore>{mainScore}</PercentScore>
            </PanelFrontContent>
          </TopPanelFront>
        </Panel>
      </TopWrapper>

      <BottomWrapper>
        <BottomSection>
          <BottomTitle>Attack Vectors</BottomTitle>
          <VectorsSection>{vectorsElements}</VectorsSection>
        </BottomSection>

        <BottomSection>
          <div>
            <BottomTitle>Alerts Severity</BottomTitle>
            <Content>
              <PieChartComponent
                data={severityData}
                cellColors={SEVERITY_COLORS}
              />
              <div className="ml-5 mt-2">{severityElements}</div>
            </Content>
          </div>
        </BottomSection>

        <BottomSection>
          <div>
            <BottomTitle>Alerts Categories</BottomTitle>
            <Content>
              <PieChartComponent
                data={categoriesData}
                cellColors={CATEGORIES_COLORS}
              />
              <div className="ml-5 mt-3">{categoriesElements}</div>
            </Content>
          </div>
        </BottomSection>
      </BottomWrapper>
    </MainWrapper>
  )
}

export default Header
